import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'

/* container */
import IouContainer from '../../app-module-iou-container/default'
/* container */

/* package */
import { ModPublicWrapp } from '../../lib-atomic-design-section'
import { ModMainWrapp } from '../../lib-atomic-design-section'
import { GlobalContext } from '../../lib-atomic-context'
/* package */

/* form */
import IOUPopup from '../popup/ioupopup'
/* form */

import CONFIG from '../config'

/* CONSTANTS */
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
    justifyContent: 'space-between',
    // overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    paddingBottom: 80,
    maxWidth: 380,
    // minWidth: 320,
    margin: 'auto',
  },
  gridList: {
    width: 800,
  },
}))
const mediaPath = CONFIG.setup.assets.media
/* CONSTANTS */

const index = (props) => {
  const classes = useStyles()
  /* state */
  const { bannerscontents } = useContext(GlobalContext)
  const imgToDisplay = bannerscontents.state.data.masterbannerscontents.filter(
    (page) => {
      return page.pageName === 'Verification'
    }
  )[0]
  /* state */

  return (
    <IouContainer {...props}>
      {/* <ModPublicWrapp {...props} imgToDisplay={imgToDisplay}> */}
      <div className={classes.root}>
        <IOUPopup {...props} />
      </div>
      {/* </ModPublicWrapp> */}
    </IouContainer>
  )
}

export default index
